// import React from 'react';
// import CommonDateInput from '../../../components/CommonDateInput';

// /**
//  * Reusable form tab component for PO forms
//  */
// export default function CommonFormTab({ fields, formData, onChange, readOnly = false, formSubmissionAttempted = false, mode = 'create' }) {
//   // Date fields that should use date picker
//   const datePickerFields = [
//     'expectedReceiptDate',
//     'closedDate',
//     'loadingDate',
//     'editDate',
//     'customField4'
//   ];

//   // Date-time fields that should show time when read-only
//   const dateTimeFields = [
//     'purchaseOrderDate',
//     'createDate',
//     'editDate'
//   ];

//   return (
//     <div className="row g-3">
//       {fields.map((field) => {


//         if (mode === 'create' && !readOnly && field.hiddenOnCreate) {
//           return null;
//         }

//         const fieldReadOnlyInThisMode = (mode === 'edit' && field.readOnlyInEdit) ? true : false;

//         const effectiveReadOnly = readOnly || field.readOnly || fieldReadOnlyInThisMode;
//         const effectiveDisabled = field.disabled || effectiveReadOnly;


//         const isRequired = field.required && !field.readOnly && !readOnly;
//         const fieldValue = formData[field.name];
//         const isEmpty = fieldValue === null || fieldValue === undefined || fieldValue === '' ||
//           (typeof fieldValue === 'string' && fieldValue.trim() === '');
//         const hasError = formSubmissionAttempted && isRequired && isEmpty;

//         const isDateTimeField = dateTimeFields.includes(field.name);
//         const isDateField = field.type === 'date' || datePickerFields.includes(field.name);

//         return (
//           <div className="col-md-2" key={field.name}>
//             <label htmlFor={field.name} className="form-label">
//               {field.label}
//               {isRequired && <span className="text-danger"> *</span>}
//             </label>

//             {field.type === "select" ? (
//               <select
//                 id={field.name}
//                 className={`form-select ${hasError ? 'is-invalid' : ''}`}
//                 name={field.name}
//                 value={formData[field.name] || ""}
//                 onChange={onChange}
//                 disabled={effectiveDisabled}
//                 required={isRequired}
//               >
//                 <option value="">Select...</option>
//                 {field.options?.map((opt) =>
//                   typeof opt === 'object' ? (
//                     <option key={opt.value} value={opt.value}>{opt.label}</option>
//                   ) : (
//                     <option key={opt} value={opt}>{opt}</option>
//                   )
//                 )}
//               </select>
//             ) : field.type === "textarea" ? (
//               <textarea
//                 id={field.name}
//                 className={`form-control ${hasError ? 'is-invalid' : ''}`}
//                 name={field.name}
//                 value={formData[field.name] || ""}
//                 onChange={onChange}
//                 disabled={effectiveDisabled}
//                 required={isRequired}
//                 rows={3}
//               />
//             ) : isDateTimeField || isDateField ? (
//               <CommonDateInput
//                 id={field.name}
//                 name={field.name}
//                 value={formData[field.name]}
//                 onChange={onChange}
//                 readOnly={effectiveReadOnly}
//                 disabled={effectiveDisabled}
//                 required={isRequired}
//                 className={hasError ? 'is-invalid' : ''}
//                 showTime={isDateTimeField}
//                 allowPastDates={false} // Only allow current and future dates
//               />
//             ) : (
//               <input
//                 id={field.name}
//                 type={field.type || "text"}
//                 className={`form-control ${hasError ? 'is-invalid' : ''}`}
//                 name={field.name}
//                 value={formData[field.name] || ""}
//                 onChange={onChange}
//                 disabled={effectiveDisabled}
//                 required={isRequired}
//                 placeholder={field.placeholder}
//               />
//             )}

//             {hasError && (
//               <div className="invalid-feedback">
//                 {field.label} is required
//               </div>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// }



import React, { useEffect, useRef } from 'react';
import CommonDateInput from '../../../components/CommonDateInput';
import PartnerLookupField from '../../../components/PartnerLookupField';

/**
 * Reusable form tab component for PO forms
 */
export default function CommonFormTab({
  fields,
  formData,
  onChange,
  readOnly = false,
  formSubmissionAttempted = false,
  mode = 'create'
}) {
  // ----- helpers -----
  const pad = (n) => String(n).padStart(2, '0');
  const nowLocalISO = () => {
    const d = new Date();
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };
  const datePart = (dt) =>
    typeof dt === 'string' && dt.includes('T') ? dt.slice(0, 10) : dt;

  const toISODate = (val) => {
    if (!val) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val; // already ISO
    const m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(val);  // dd-MM-yyyy
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;
    return val;
  };

  const addMonths = (isoDate, months = 0) => {
    // isoDate: YYYY-MM-DD
    if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return isoDate;
    const [y, m, d] = isoDate.split('-').map(Number);
    const base = new Date(y, m - 1, d);
    const targetMonth = base.getMonth() + months;
    const tmp = new Date(base);
    tmp.setMonth(targetMonth);

    // Handle month overflow (e.g., adding 6 months to Aug 31 → Feb end)
    if (tmp.getMonth() !== ((targetMonth % 12) + 12) % 12) {
      // set to last day of previous month
      tmp.setDate(0);
    }

    const yyyy = tmp.getFullYear();
    const mm = pad(tmp.getMonth() + 1);
    const dd = pad(tmp.getDate());
    return `${yyyy}-${mm}-${dd}`;
  };

  // Prefill once on mount (create mode)
  const prefilledRef = useRef(false);
  useEffect(() => {
    if (prefilledRef.current) return;
    if (readOnly) return;
    if (mode !== 'create') return;

    const patches = {};
    let changed = false;

    // 1) Created Date (purchaseOrderDate) -> now if empty
    if (!formData?.purchaseOrderDate || String(formData.purchaseOrderDate).trim() === '') {
      patches.purchaseOrderDate = nowLocalISO();
      changed = true;
    }

    const created = patches.purchaseOrderDate ?? formData?.purchaseOrderDate;
    const createdDateOnly = created ? datePart(created) : null;

    // 2) Expected Receipt Date = Created Date (date part) if empty
    if (!formData?.expectedReceiptDate || String(formData.expectedReceiptDate).trim() === '') {
      if (createdDateOnly) {
        patches.expectedReceiptDate = createdDateOnly; // YYYY-MM-DD
        changed = true;
      }
    } else {
      // normalize dd-MM-yyyy -> ISO
      const iso = toISODate(formData.expectedReceiptDate);
      if (iso !== formData.expectedReceiptDate) {
        patches.expectedReceiptDate = iso;
        changed = true;
      }
    }

    // 3) Validity Date = Created Date + 6 months (user can change later)
    if (!formData?.validityDate || String(formData.validityDate).trim() === '') {
      if (createdDateOnly) {
        patches.validityDate = addMonths(createdDateOnly, 6);
        changed = true;
      }
    } else {
      const iso = toISODate(formData.validityDate);
      if (iso !== formData.validityDate) {
        patches.validityDate = iso;
        changed = true;
      }
    }

    // 4) Type default = "Standard" (changeable)
    if (!formData?.type || String(formData.type).trim() === '') {
      patches.type = 'Standard';
      changed = true;
    }

    // (Optional) Respect per-field defaultValue from schema
    fields.forEach((f) => {
      if (f?.defaultValue !== undefined) {
        const cur = formData?.[f.name];
        if (cur === undefined || cur === null || cur === '') {
          patches[f.name] = f.defaultValue;
          changed = true;
        }
      }
    });

    if (changed) {
      Object.entries(patches).forEach(([name, value]) => {
        onChange({ target: { name, value } });
      });
    }
    prefilledRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, readOnly, fields, formData]);

  // Date fields that should use date picker (add validityDate)
  const datePickerFields = [
    'expectedReceiptDate',
    'validityDate',     // ✅ added
    'closedDate',
    'loadingDate',
    'editDate',
    'customField4'
  ];

  // Date-time fields that should show time when read-only
  const dateTimeFields = ['purchaseOrderDate', 'createDate', 'editDate'];

  return (
    <div className="row g-3">
      {fields.map((field) => {
        if (mode === 'create' && !readOnly && field.hiddenOnCreate) {
          return null;
        }

        const fieldReadOnlyInThisMode =
          mode === 'edit' && field.readOnlyInEdit ? true : false;

        const effectiveReadOnly = readOnly || field.readOnly || fieldReadOnlyInThisMode;
        const effectiveDisabled = field.disabled || effectiveReadOnly;

        const isRequired = field.required && !field.readOnly && !readOnly;
        const rawValue = formData[field.name];

        // Normalize date values for date inputs
        const isDateTimeField = dateTimeFields.includes(field.name);
        const isDateField = field.type === 'date' || datePickerFields.includes(field.name);
        const normalizedValue =
          isDateField && rawValue ? toISODate(rawValue) : rawValue;

        const isEmpty =
          normalizedValue == null ||
          normalizedValue === '' ||
          (typeof normalizedValue === 'string' && normalizedValue.trim() === '');
        const hasError = formSubmissionAttempted && isRequired && isEmpty;

        return (
          <div className="col-md-2" key={field.name}>
            <label htmlFor={field.name} className="form-label">
              {field.label}
              {isRequired && <span className="text-danger"> *</span>}
            </label>

            {field.type === 'select' ? (
              <select
                id={field.name}
                className={`form-select ${hasError ? 'is-invalid' : ''}`}
                name={field.name}
                value={normalizedValue || ''}
                onChange={onChange}
                disabled={effectiveDisabled}
                required={isRequired}
              >
                {field.options?.map((opt) =>
                  typeof opt === 'object' ? (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ) : (
                    <option key={opt} value={opt}>{opt}</option>
                  )
                )}
              </select>
            ) : field.type === 'textarea' ? (
              <textarea
                id={field.name}
                className={`form-control ${hasError ? 'is-invalid' : ''}`}
                name={field.name}
                value={normalizedValue || ''}
                onChange={onChange}
                disabled={effectiveDisabled}
                required={isRequired}
                rows={3}
              />
            ) : field.type === 'partnerLookup' ? (
              <PartnerLookupField
                name={field.name}
                value={normalizedValue || ''}
                disabled={effectiveDisabled}
                required={isRequired}
                isInvalid={hasError}
                modalTitle={`Select ${field.label}`}
                onSelect={(partner) =>
                  onChange({ target: { name: field.name, value: partner?.partner_id || '' } })
                }
              />
            ) : isDateTimeField || isDateField ? (
              <CommonDateInput
                id={field.name}
                name={field.name}
                value={normalizedValue}
                onChange={onChange}
                readOnly={effectiveReadOnly}
                disabled={effectiveDisabled}
                required={isRequired}
                className={hasError ? 'is-invalid' : ''}
                showTime={isDateTimeField}
                allowPastDates={false} // validity should be future-friendly; this already disallows past
              />
            ) : (
              <input
                id={field.name}
                type={field.type || 'text'}
                className={`form-control ${hasError ? 'is-invalid' : ''}`}
                name={field.name}
                value={normalizedValue || ''}
                onChange={onChange}
                disabled={effectiveDisabled}
                required={isRequired}
                placeholder={field.placeholder}
              />
            )}

            {hasError && (
              <div className={`invalid-feedback ${field.type === 'partnerLookup' ? 'd-block' : ''}`}>{field.label} is required</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
